let stepCount = {
    props: ['step'],
    template: '\
    <span v-if="step.total>2" class="u-font-tiny">（<span class="current">{{ step.current }}</span><span>／{{ step.total }}</span>）</span>'
}